exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".password-validation{text-align:left}.password-validation.title{font-weight:700;margin-bottom:5px}.password-validation li{line-height:15px}.password-validation li .password-validation-icon{width:15px;font-size:15px}.password-validation .text-danger{color:#232323 !important}.password-validation .text-success{color:#0f9d58}", ""]);

// exports
